var map = {
	"./en/download-aplication.ts": 198,
	"./en/open-app-banner.ts": 199,
	"./en/pre-contact.ts": 200,
	"./en/safetag-final-thank-you.ts": 201,
	"./en/safetag-not-linked-with-app.ts": 202,
	"./en/safetag-not-linked.ts": 203,
	"./en/scanned-safetag.ts": 204,
	"./en/tag-found.ts": 205,
	"./es/download-aplication.ts": 206,
	"./es/open-app-banner.ts": 207,
	"./es/pre-contact.ts": 208,
	"./es/safetag-final-thank-you.ts": 209,
	"./es/safetag-not-linked-with-app.ts": 210,
	"./es/safetag-not-linked.ts": 211,
	"./es/scanned-safetag.ts": 212,
	"./es/tag-found.ts": 213,
	"./fr/download-aplication.ts": 214,
	"./fr/open-app-banner.ts": 215,
	"./fr/pre-contact.ts": 216,
	"./fr/safetag-final-thank-you.ts": 217,
	"./fr/safetag-not-linked-with-app.ts": 218,
	"./fr/safetag-not-linked.ts": 219,
	"./fr/scanned-safetag.ts": 220,
	"./fr/tag-found.ts": 221,
	"./pt/download-aplication.ts": 222,
	"./pt/open-app-banner.ts": 223,
	"./pt/pre-contact.ts": 224,
	"./pt/safetag-final-thank-you.ts": 225,
	"./pt/safetag-not-linked-with-app.ts": 226,
	"./pt/safetag-not-linked.ts": 227,
	"./pt/scanned-safetag.ts": 228,
	"./pt/tag-found.ts": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 197;